import React from "react";
import Image from "react-bootstrap/Image";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";

import { Helmet } from "react-helmet";

// Shared assets reused from Loyalty Management page
import DataConsultantsIcon from "../assets/images/icons/dataConsultants.png";
import inTheMartechIndustryIcon from "../assets/images/icons/inTheMartechIndustry.png";
import expertsIcon from "../assets/images/icons/experts.png";
import topPartnersIcon from "../assets/images/icons/topPartners.png";
import MartechSMEsIcon from "../assets/images/icons/Martech-SMEs.png";
import salesforceArrow from "../assets/images/salesforce-arrow.png";

import slackBannerMobile from "../assets/images/banner/happy-businesswoman-with-speech-bubble.png";
import compassIcon from "../assets/images/icons/compass.png";
import powerIcon from "../assets/images/icons/power.png";
import flashIcon from "../assets/images/icons/flash.png";
import lineIcon from "../assets/images/icons/line.png";
import lockIcon from "../assets/images/icons/lock.png";
import continuesIcon from "../assets/images/icons/continuous.png";

import gearsIcon from "../assets/images/icons/gears.png";
import enterpriseIcon from "../assets/images/icons/enterprise.png";

import layerOne from "../assets/images/layers/GroupLeft.png";
import layerTwo from "../assets/images/layers/GroupRight.png";
import BrainIcon from "../assets/images/icons/brain.png";


import executionIcon from "../assets/images/icons/execution.png";



const Slack = () => {
    return (
        <>
            <Helmet>
                <title>How Comsense Helps Teams Get More Value from Slack</title>

                <meta
                    name="description"
                    content="Discover how Comsense integrates Slack with Salesforce to improve collaboration, faster decision-making, and team productivity."
                />

                <meta
                    name="keywords"
                    content="Comsense Slack integration, Salesforce Slack integration, Slack collaboration tools, Salesforce workflow automation,AI in Slack, Salesforce productivity, Slack CRM integration, Comsense Technologies"
                />

                <meta name="robots" content="index, follow" />
                <meta name="author" content="Comsense Technologies" />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="How Comsense Helps Teams Get More Value from Slack"
                />
                <meta
                    property="og:description"
                    content="Discover how Comsense integrates Slack with Salesforce to improve collaboration, faster decision-making, and team productivity."
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:url"
                    content="https://www.comsensetechnologies.com/slack"
                />
            </Helmet>
            <header class="masthead subPageHead data-cloud-header slackBanner">
                <div class="container">
                    <Row className="justify-content-start">
                        <Col xl={7} lg={5}>
                            {/* <Image src={shape3} className='shape3 d-none d-md-block' /> */}
                            <h1 class="masthead-heading text-white">
                                Slack{" "}
                                <span className="fancy-text4 ps-1 pe-2 mb-0  z-0 text-EE0000  position-relative overflow-hiddens text-white">
                                    Services{" "}
                                </span>
                                <br />

                            </h1>
                            <p className="mt-4 ls-0 fw-600 fs-4 text-white">
                                Turn conversations into action, instantly                            </p>

                            {/* <Image src={shape4} className='shape4 d-none d-md-block' />
                            <Image src={shape5} className='shape5 d-none d-md-block' /> */}
                        </Col>
                        <Col lg={12} className="mt-5 mt-lg-0 d-block d-lg-none">
                            <Image className="w-100" src={slackBannerMobile} />
                        </Col>
                    </Row>
                </div>
            </header>


            <section className="bg-EFFDFF pt-80 pb-80">
                <Container>
                    <Row className="align-items-center mb-3">
                        <Col col={12}>
                            <div className="text-center d-flex align-items-center justify-content-center">
                                <h2 className="section-heading section-heading-center fw-700 fs-2">
                                    The <span className="bordered-text">Execution Layer</span> for AI-Driven Work
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4 text-center justify-content-center">
                        <Col lg={11} md={12} className="mb-2 mb-lg-0">
                            <p className="mt-0 fs-5 fw-normal ls-0">
                                From sales and service to marketing and operations, Slack enables faster decisions, streamlined execution, and seamless coordination across functions.
                            </p>
                            <p className="mt-0 fs-5 fw-normal ls-0">
                                By integrating deeply with Salesforce and Agentforce, Slack ensures that insights don’t just stay in systems, but translate into action, driving efficiency, alignment, and better business outcomes.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="page-section pt-80 pb-80 bg-white">
                <Container>
                    <Row className="align-items-center mb-5">
                        <Col col={12}>
                            <div className="text-center d-flex align-items-center justify-content-center">
                                <h2 className="section-heading section-heading-center fw-700 fs-2">
                                    How Slack Works with <span className="bordered-text">Agentforce</span>
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4 justify-content-center">
                        <Col lg={12}>
                            <div className="bg-E2F1FE p-5 rounded-4 shadow-sm">
                                <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-4">
                                    <div className="execution-step">
                                        <h4 className="fw-700 mb-2">Agentforce generates insights</h4>
                                        <p className="mb-0">Next-best actions, alerts, recommendations</p>
                                    </div>
                                    <div className="d-none d-md-block">
                                        <Image width={30} src={salesforceArrow} style={{ transform: 'rotate(0deg)' }} />
                                    </div>
                                    <div className="execution-step">
                                        <h4 className="fw-700 mb-2">Slack operationalizes them</h4>
                                        <p className="mb-0">Channels, workflows, approvals, execution</p>
                                    </div>
                                    <div className="d-none d-md-block">
                                        <Image width={30} src={salesforceArrow} style={{ transform: 'rotate(0deg)' }} />
                                    </div>
                                    <div className="execution-step">
                                        <h4 className="fw-700  mb-2">Teams act in real time</h4>
                                        <p className="mb-0">Faster outcomes, fewer bottlenecks</p>
                                    </div>
                                </div>
                                <p className="mt-5 text-252B42 ls-0 text-center fw-500 fs-20 mb-0 text-center">
                                    Together, they create a system that doesn’t just inform—but <span className="fw-700">moves the business forward</span>.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


            <section className="page-section pt-0 pb-70 bg-FFF">
                <Container>
                    <Row className="align-items-center mb-5">
                        <Col col={11}>
                            <div className="text-center d-flex align-items-center justify-content-center">
                                <h2 className="section-heading section-heading-center fw-700 fs-2">
                                    How we help you succeed with <span className="bordered-text">Slack</span>
                                </h2>
                            </div>
                            <p className="text-252B42 ls-0 text-center fw-500 fs-20">
                                Turning collaboration into execution requires the right structure, integration, and governance.
                            </p>
                        </Col>
                    </Row>
                    <Row className="align-items-center mt-4 justify-content-start position-relative">
                        <Col lg={12}>
                            <Row>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4 d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={compassIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Strategy & Design
                                            </h5>
                                            <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                                                Define channels, workflows, and governance aligned to your goals.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4  d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={powerIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Salesforce Integration
                                            </h5>
                                            <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                                                Connect Slack with CRM and Agentforce for real-time execution.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4  d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={flashIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Workflow Automation
                                            </h5>
                                            <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                                                Design and deploy workflows to reduce manual effort and delays.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4  d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={lineIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Team Enablement
                                            </h5>
                                            <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                                                Align sales, service, and marketing within shared workflows.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4  d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={lockIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Governance & Security
                                            </h5>
                                            <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                                                Ensure structured, secure, and compliant Slack usage.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4  d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={continuesIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Continuous Optimization
                                            </h5>
                                            <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                                                Refine workflows and collaboration to drive ongoing efficiency.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container >
            </section >


            <section className="page-section bg-EFFDFF pt-70 pb-70">
                <Container>
                    <Row className="align-items-center mb-5">
                        <Col col={11}>
                            <div className="text-center">
                                <h2 className="section-heading section-heading-center fw-700 fs-2">
                                    Why Comsense for {" "}
                                    <span className="bordered-text">Slack Service</span>
                                </h2>
                                <p className="text-252B42 ls-0 text-center fw-500 fs-20">
                                    We don’t implement Slack in isolation; we design it as part of your execution ecosystem.
                                </p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="align-items-center mt-4 justify-content-start position-relative">
                        <Col lg={12}>
                            <Row>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4 d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={powerIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Deep integration with Agentforce and Salesforce ecosystem
                                            </h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4  d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={flashIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Outcome-linked workflow design (tied to business KPIs)
                                            </h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4  d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={gearsIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Proprietary AI models / accelerators
                                            </h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6} md={6}>
                                    <div className="mb-4 mb-lg-4  d-flex align-items-center">
                                        <div>
                                            <div className="blue-gradient-sqr-icon text-center position-relative">
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={enterpriseIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                                                Enterprise-ready scalability
                                            </h5>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="page-section pt-70 pb-70 bg-white">
                <Container>
                    <Row className="align-items-center mt-4 justify-content-center testimonials-area position-relative">
                        <Col
                            xl={2}
                            lg={2}
                            md={4}
                            sm={6}
                            xs={12}
                            className="cus-col-sm text-center"
                        >
                            <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                                <div className="position-relative">
                                    <Image width={70} className="m-auto" src={MartechSMEsIcon} />
                                </div>
                                <h5 className="mb-1 mt-4 fw-800 fs-4">40+</h5>
                                <p className="fw-500 fs-6">Workflow Automations Delivered</p>
                            </div>
                        </Col>
                        <Col
                            xl={2}
                            lg={2}
                            md={4}
                            sm={6}
                            xs={12}
                            className="cus-col-sm text-center"
                        >
                            <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                                <div className="position-relative">
                                    <Image
                                        width={70}
                                        className="m-auto"
                                        src={DataConsultantsIcon}
                                    />
                                </div>
                                <h5 className="mb-1 mt-4 fw-800 fs-4">25+</h5>
                                <p className="fw-500 fs-6">Slack & Collaboration Specialists</p>
                            </div>
                        </Col>
                        <Col
                            xl={2}
                            lg={2}
                            md={4}
                            sm={6}
                            xs={12}
                            className="cus-col-sm text-center"
                        >
                            <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                                <div className="position-relative">
                                    <Image
                                        width={70}
                                        className="m-auto"
                                        src={inTheMartechIndustryIcon}
                                    />
                                </div>
                                <h5 className="mb-1 mt-4 fw-800 fs-4">10+ Years</h5>
                                <p className="fw-500 fs-6">in the Martech Industry</p>
                            </div>
                        </Col>
                        <Col
                            xl={2}
                            lg={2}
                            md={4}
                            sm={6}
                            xs={12}
                            className="cus-col-sm text-center"
                        >
                            <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                                <div className="position-relative">
                                    <Image width={70} className="m-auto" src={expertsIcon} />
                                </div>
                                <h5 className="mb-1 mt-4 fw-800 fs-4">Cross-Functional</h5>
                                <p className="fw-500 fs-6">Enterprise Implementations</p>
                            </div>
                        </Col>
                        <Col
                            xl={2}
                            lg={2}
                            md={4}
                            sm={6}
                            xs={12}
                            className="cus-col-sm text-center"
                        >
                            <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                                <div className="position-relative">
                                    <Image width={70} className="m-auto" src={topPartnersIcon} />
                                </div>
                                <h5 className="mb-1 mt-4 fw-800 fs-4">Top Partners</h5>
                                <p className="fw-500 fs-6">of Salesforce</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>



            <section class="page-section pt-80 pb-80 bg-E2F1FE">
                <Container>
                    <Row className="align-items-center mb-0">
                        <Col col={11}>
                            <div class="text-center d-flex align-items-center justify-content-center">
                                <h2 class="section-heading section-heading-center fw-700 fs-2">
                                    <span className="fancy-text2 ps-2 mb-3 pe-3 z-0  position-relative overflow-hiddens text-white">
                                        Powering
                                    </span>{" "}
                                    Intelligent Execution
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className="align-items-center mt-3 justify-content-center position-relative">
                        <Col lg={12}>
                            <Row className="justify-content-center">

                                <Col lg={5} md={6}>
                                    <div className="mb-4 mb-lg-4 d-flex align-items-center">
                                        <div>
                                            <div
                                                style={{
                                                    width: "50px",
                                                    height: "50px",
                                                    lineHeight: "45px",
                                                }}
                                                className="box-shadow-two bg-white text-center position-relative rounded-0"
                                            >
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={BrainIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-500 fs-5 ls-minus-05">
                                                Agentforce delivers the intelligence.
                                            </h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={5} md={6}>
                                    <div className="mb-4 mb-lg-4 d-flex align-items-center">
                                        <div>
                                            <div
                                                style={{
                                                    width: "50px",
                                                    height: "50px",
                                                    lineHeight: "45px",
                                                }}
                                                className="box-shadow-two bg-white text-center position-relative rounded-0"
                                            >
                                                <Image
                                                    width={30}
                                                    className="m-auto"
                                                    src={executionIcon}
                                                />
                                            </div>
                                        </div>
                                        <div className="content ms-4 pe-3">
                                            <h5 className="mb-2 fw-500 fs-5 ls-minus-05">
                                                Slack delivers the execution.
                                            </h5>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <p className="mt-4 text-252B42 ls-0 text-center fw-500 fs-20 mb-0 text-center">
                        Together, they enable faster decisions, aligned teams, and seamless action across the enterprise.
                    </p>
                </Container>
            </section>

            <section class="page-section z-0 bg-FFF overflow-hidden pt-70 pb-70 position-relative">
                <Image
                    className="position-absolute z-n1 w-250 bg-cover h-auto position-absolute start-0 bottom-0"
                    src={layerOne}
                />
                <Container>
                    <Row className="align-items-center justify-content-center">
                        <Col lg={7}>
                            <div class="text-center">
                                <h2
                                    class="text-252B42 fw-700 fs-26"
                                    style={{ lineHeight: "normal" }}
                                >
                                    Turn Insight into Action
                                </h2>
                                <p className="text-252B42 fw-600 ls-minus036 mt-4 mb-2 fs-4">
                                    Bring your teams, data, and AI together in one execution layer.                </p>
                                <p className="ls-minus036 fs-13 fw-700">
                                    Design. Integrate. Execute—with Slack and Agentforce.                </p>
                                <Nav.Link
                                    className="d-inline-block  text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                                    as={Link}
                                    to="../contact"
                                >
                                    Build Your Execution Layer
                                </Nav.Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Image
                    className="position-absolute w-250 z-n1 bg-cover h-auto position-absolute end-0 top-0 opacity-25"
                    src={layerTwo}
                />
            </section>

        </>
    );
};

export default Slack;
